//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import React from "react";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { themeGet } from "@styled-system/theme-get";
import { Flex } from "@chakra-ui/react";

const sizeOptions: { [key: string]: string } = {
  small: "4px",
  regular: "8px",
  big: "12px",
  bigger: "16px",
};

const LinearAnimation = keyframes`
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`;

const Dot: React.FC<{ [key: string]: any }> = styled.div`
  background-color: ${(props) => themeGet(`colors.${props.color}`)};
  border-radius: 100%;
  width: ${(props) => sizeOptions[props.size]};
  height: ${(props) => sizeOptions[props.size]};
  margin-right: 4px;

  /* Animation */
  animation: ${LinearAnimation} 1.4s infinite ease-in-out both;
  animation-delay: ${(props) => props.delay};
`;

type Props = {
  color?: string;
  size?: string;
  [key: string]: any;
};

const LoadingDots = ({ color, size, ...rest }: Props) => {
  return (
    <Flex alignItems="center" {...rest}>
      <Dot delay="-0.32s" {...{ color, size }} />
      <Dot delay="-0.16s" {...{ color, size }} />
      <Dot delay="0s" {...{ color, size }} />
    </Flex>
  );
};

export default LoadingDots;

LoadingDots.defaultProps = {
  size: "regular",
  color: "gray.400",
};
